import {
    faTwitter as Twitter,
    faFacebookF as Facebook,
    faInstagram as Instagram,
    faPinterestP as Pinterest,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

const ShareNav = styled.ul`
    width: 140px;
    margin-bottom: 0px;
`;

const ShareMediaNav = (props) => {
    const fullUrl = window.location.href;
    return (
        <ShareNav className='d-flex justify-content-between ps-3'>
            <li className='circle-btn-orange'>
                <a
                    href={'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href}
                    aria-label={`go to Facebook`}
                    target='_blank'
                    rel='noreferrer noopener'
                >
                    <FontAwesomeIcon icon={Facebook} className='fa-lg' />
                </a>
            </li>
            <li className='circle-btn-orange'>
                <a
                    href={'https://twitter.com/intent/tweet?url=' + window.location.href}
                    aria-label={`go to Twitter`}
                    target='_blank'
                    rel='noreferrer noopener'
                >
                    <FontAwesomeIcon icon={Twitter} className='fa-lg' />
                </a>
            </li>
            <li className='circle-btn-orange'>
                <a
                    data-pin-do="buttonBookmark"
                    data-pin-custom="true"
                    data-pin-round="true"
                    href={"http://pinterest.com/pin/create/button/?url={"+fullUrl+"}&media={"+props.image+"}&description={I want to share this awesome recipe}"}
                    target="_blank"
                >
                    <FontAwesomeIcon icon={Pinterest} className='fa-lg' />
                </a>
            </li>
        </ShareNav>
    );
};

export default ShareMediaNav;
